const defaultState = {
  visibleVideo: false,
};

const mediaRecorderReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SHOW_VIDEO_RECORDER': {
      return {
        ...state,
        visibleVideo: true,
      };
    }
    case 'HIDE_VIDEO_RECORDER': {
      return {
        ...state,
        visibleVideo: false,
      };
    }
    default:
      return state;
  }
};

export default mediaRecorderReducer;
